<template>
  <b-card
    class="cardStyle"
    style="height: 100%;font-weight: 400;font-size: 16px;line-height: 20px;"
  >
    <p class="labelStyle">{{ label }}</p>
    <hr class="solid" />
    <p class="descriptionStyle">{{ description }}</p>
    <div>
      <b-icon icon="question-circle-fill" scale="1"></b-icon>
      <b-button variant="link" @click="redirectToPfizerSupport">{{ linkText }}</b-button>
    </div>
  </b-card>
</template>

<script>
  export default {
    name: 'app-support',
    data() {
      return {
        label: 'Pfizer Guide to Application Support',
        description:
          'This guide will help you reach the correct team responsible for the support of various applications used on Pfizer studies.',
        linkText: 'Pfizer Guide to Application Support',
      };
    },
    methods: {
      redirectToPfizerSupport() {
        this.$router.push({ name: 'pfizer-application-support' });
      },
    },
  };
</script>

<style scoped>
  .labelStyle {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    color: #383838;
  }

  .descriptionStyle {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.5px;
    color: #006a68;
  }
</style>
